import { z } from 'zod'

/**
 * A catalogue card from `GET /v1/integrations/toolkits`.
 *
 * `connectable` and `supported` are separate on purpose: an app can be
 * connectable at Composio while the agent still has no read-only actions for
 * it. Only both together earn a live Connect button.
 */
export const toolkitSchema = z
  .object({
    slug: z.string(),
    name: z.string(),
    description: z.string().nullish(),
    logo: z.string().nullish(),
    categories: z.array(z.unknown()).optional().default([]),
    tools_count: z.number().nullish(),
    no_auth: z.boolean().optional().default(false),
    connectable: z.boolean().optional().default(false),
    supported: z.boolean().optional().default(false),
    deprecated: z.boolean().optional().default(false),
  })
  .passthrough()

export const toolkitListSchema = z.object({
  items: z.array(toolkitSchema).default([]),
  total: z.number().optional(),
})

export const toolkitCategorySchema = z.object({
  slug: z.string(),
  name: z.string(),
})

export const toolkitCategoryListSchema = z.object({
  items: z.array(toolkitCategorySchema).default([]),
})
